import { SuppliesType } from "~/utils/constants";

export const defaultCategories = [
  { id: "packing", name: "Packing" },
  { id: "fabrication", name: "Fabrication" },
  { id: "shipping", name: "Shipping" },
  { id: "cleaning", name: "Cleaning" },
  { id: "maintenance", name: "Maintenance" },
  { id: "miscellaneous", name: "Miscellaneous" },
  { id: "custom", name: "Custom" },
];

export const categories = {
  [SuppliesType.TOOLS_KITS_AND_HARDWARE]: defaultCategories,
  [SuppliesType.INTERNAL_SUPPLIES_AND_FACILITIES]: defaultCategories,
  [SuppliesType.PACKAGING_MATERIALS]: defaultCategories,
  [SuppliesType.PPE]: defaultCategories,
  [SuppliesType.EQUIPMENT]: defaultCategories,
};
